import React from "react";
import StationForm from "./StationForm";

export default function StationAdd() {
  return <StationForm mode="add" />;
}
